/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { MdDelete, MdClose } from "react-icons/md";
import PackageService from "../../../services/package.service";
import { fromPhotos } from "../../../utils";
import ConfirmModal from "../../../components/confirm-modal";

const ViewPhotosDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const item = state?.item || {};

  const [photos, setPhotos] = useState([]);
  const [fullscreenIndex, setFullscreenIndex] = useState(null);

  // Estados para el Modal de Confirmación
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  useEffect(() => {
    loadPhotos();
  }, []);

  const loadPhotos = () => {
    const rawPhotos = item?.photos || [];
    const formatted = rawPhotos.map((i) => ({
      ...i,
      url: fromPhotos ? fromPhotos(i.url) : i.url,
    }));
    setPhotos(formatted);
  };

  const openDeleteModal = (photo, e) => {
    e.stopPropagation();
    setSelectedPhoto(photo);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedPhoto) return;
    setLoadingDelete(true);
    try {
      const res = await PackageService.admin.deletePhotos({
        photo_id: selectedPhoto.id,
      });
      if (res.result) {
        toast.success("Se ha eliminado la foto");
        setPhotos((prev) => prev.filter((p) => p.id !== selectedPhoto.id));
        setIsDeleteModalOpen(false);
        setSelectedPhoto(null);
      } else {
        toast.error("No se pudo eliminar la foto");
      }
    } catch (error) {
      const errorMsg =
        typeof error === "string"
          ? error
          : error?.response?.data?.message ||
            error?.message ||
            "Error al eliminar la foto";
      toast.error(errorMsg);
    } finally {
      setLoadingDelete(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto py-6 px-4 md:px-8">
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-sm font-bold text-[#1D3B8B] hover:underline"
        >
          ← Volver
        </button>
        <p className="text-xs text-gray-500 text-center font-medium">
          Haz clic en la papelera para eliminar la foto o en la imagen para
          ampliarla
        </p>
      </div>

      {photos.length === 0 ? (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 text-center text-gray-400">
          No hay fotos registradas para este elemento.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {photos.map((photo, index) => (
            <div
              key={photo.id || index}
              onClick={() => setFullscreenIndex(index)}
              className="relative group aspect-square rounded-xl overflow-hidden bg-gray-100 border border-gray-200 shadow-sm cursor-pointer transition-transform hover:scale-[1.02]"
            >
              <img
                src={photo.url}
                alt="Evidencia"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <button
                  type="button"
                  onClick={(e) => openDeleteModal(photo, e)}
                  className="p-3 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors shadow-lg"
                  title="Eliminar foto"
                >
                  <MdDelete size={20} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL FULLSCREEN */}
      {fullscreenIndex !== null && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4">
          <button
            onClick={() => setFullscreenIndex(null)}
            className="absolute top-6 right-6 text-white bg-white/10 hover:bg-white/20 p-3 rounded-full transition-colors"
          >
            <MdClose size={28} />
          </button>

          <img
            src={photos[fullscreenIndex]?.url}
            alt="Fullscreen"
            className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-2xl"
          />

          <div className="absolute bottom-6 text-white text-sm font-medium bg-black/50 px-4 py-2 rounded-full">
            {fullscreenIndex + 1} / {photos.length}
          </div>
        </div>
      )}

      {/* MODAL CONFIRMACIÓN DE ELIMINACIÓN */}
      <ConfirmModal
        isOpen={isDeleteModalOpen}
        title="¿Desea eliminar esta foto?"
        message="Esta acción no se puede deshacer."
        confirmText="Eliminar"
        variant="danger"
        loading={loadingDelete}
        onConfirm={handleConfirmDelete}
        onClose={() => setIsDeleteModalOpen(false)}
      />
    </div>
  );
};

export default ViewPhotosDetails;
